export const parseCurrencyValue = (value) => parseFloat(String(value ?? "0").replace(/,/g, ""))

export const normalizePriceQuantity = (quantity, index) => {
  if (index === 0) {
    return 1
  }

  const parsedQuantity = Number(quantity)
  return Number.isNaN(parsedQuantity) ? 0 : parsedQuantity
}

export const normalizePriceUtility = (utility) => {
  const parsedUtility = Number(utility)
  return Number.isNaN(parsedUtility) ? 0 : parsedUtility
}
